


















































































import Vue from 'vue'
import DataTableFooter from '@/components/DataTableFooter.vue'
import DataTableHeader from '@/components/DataTableHeader.vue'
import { mapGetters } from 'vuex'
import Message, { MessageStatus } from '@/types/Message.interface'
import Button from '@/types/components/Button.interface'
import MenuSelector from '@/components/MenuSelector.vue'
import ScheduleBuilder from '@/components/ScheduleBuilder.vue'
import TooltipActions from '@/components/TooltipActions.vue'
import ReportingItems from '@/components/ReportingItems.vue'
import Analytics from '@/services/Analytics'
interface FilterChoice {
    text: string
    active: boolean
    value: string
}
export default Vue.extend({
    name: 'MessagesTable',
    components: {
        DataTableFooter,
        DataTableHeader,
        MenuSelector,
        TooltipActions,
        ReportingItems
    },
    data() {
        return {
            // The message attributes appearing on the table
            availableAttributes: [
                {
                    text: 'Delivery Date',
                    value: 'delivered',
                    active: true
                },
                {
                    text: 'Inbound/Outbound',
                    value: 'outbound',
                    active: true
                },
                {
                    text: 'Sent From Name',
                    value: 'author',
                    active: true
                },
                {
                    text: 'Sent From Phone #',
                    value: 'from',
                    active: true
                },
                {
                    text: 'Reciever Name',
                    value: 'recipient',
                    active: true
                },
                {
                    text: 'Reciever Phone #',
                    value: 'to',
                    active: true
                },
                {
                    text: 'Message Type',
                    value: 'type',
                    active: true
                },
                {
                    text: 'Message Content',
                    value: 'text',
                    active: true
                },
                {
                    text: 'Status',
                    value: 'status',
                    active: false
                },
                {
                    text: 'Credits',
                    value: 'message_count',
                    active: false
                }
            ],
            //  The height of the primary content
            contentHeight: window.innerHeight,
            // The set height of the table
            height: '100%',
            // The number of messages that appear on screen
            itemsPerPage: 15,
            // The avaible status filters
            statusFilters: [
                {
                    text: 'delivered',
                    value: 'delivered',
                    active: false
                },
                {
                    text: 'failed',
                    value: 'failed',
                    active: false
                },
                {
                    text: 'comment',
                    value: 'comment',
                    active: false
                },
                {
                    text: 'sent',
                    value: 'sent',
                    active: false
                },
                {
                    text: 'scheduled',
                    value: 'scheduled',
                    active: false
                }
            ],
            // Filters allowed for delivery
            deliveryFilters: [
                {
                    text: 'ascending',
                    value: 'ascending',
                    active: false
                },
                {
                    text: 'descending',
                    value: 'descending',
                    active: true
                },
                {
                    text: 'delivered',
                    value: 'delivered',
                    active: false
                },
                {
                    text: 'not delivered',
                    value: 'not delivered',
                    active: false
                }
            ],
            // Filters allowed for inbound/outbound
            inOutFilters: [
                {
                    text: 'inbound',
                    value: false,
                    active: false
                },
                {
                    text: 'outbound',
                    value: true,
                    active: false
                }
            ],
            // The v-model for the text field
            search: null,
            // Message type filters available for pagination
            typeFilters: [
                {
                    text: 'auto responder',
                    value: 'autoresponder',
                    active: false
                },
                {
                    text: 'broadcast',
                    value: 'broadcast',
                    active: false
                },
                {
                    text: 'chatbot',
                    value: 'chatbot',
                    active: false
                },
                {
                    text: 'comment',
                    value: 'comment',
                    active: false
                },
                {
                    text: 'form',
                    value: 'form',
                    active: false
                },
                {
                    text: 'invoice',
                    value: 'invoice',
                    active: false
                },
                {
                    text: 'office hours',
                    value: 'office hours',
                    active: false
                },
                {
                    text: 'send',
                    value: 'send',
                    active: false
                },
                {
                    text: 'scheduled',
                    value: 'scheduled',
                    active: false
                }
            ],
            // The transformation functions, the variable must be the name of the column title within our database
            transforms: {
                outbound: (val) => this.$options.filters.inboundOutbound(val),
                from: (val) => this.$options.filters.phone(val),
                author: (val) => this.$options.filters.personFullNameOrEmail(val),
                to: (val) => this.$options.filters.phone(val),
                recipient: (val) => this.$options.filters.personFullNameOrEmail(val),
                status: (val) => val,
                delivered: (val) => this.$options.filters.formattedDatetime(val),
                type: (val) => (!val ? 'inbound' : val),
                created_at: (val) => this.$options.filters.formattedDatetime(val)
            }
        }
    },
    created() {
        // Add keydown event listener
        document.addEventListener('keydown', this.keyPressEvent)

        // Paginate messages
        this.paginateMessages()
    },
    beforeDestroy() {
        // Remove the event listener
        document.removeEventListener('keydown', this.keyPressEvent)
        window.removeEventListener('resize', this.calculateContentHeight)

        // Assign the default payload to our normal payload to reset the filters when user leaves the page (We must do Object.assign here to do a deep copy)
        Object.assign(this.payload, this.payloadDefault)

        // Paginate the changes so they are applied when user returns to the page
        this.paginateMessages(1)
    },
    mounted() {
        // Calculate and set table height
        this.setTableHeight()

        //  Calculate the height only on next tick
        this.$nextTick(() => {
            //  Calculate the current content height for initial state
            this.calculateContentHeight()

            //  Add this event listener so we recalculate the height whenever window is resized
            window.addEventListener('resize', this.calculateContentHeight)
        })
    },
    computed: {
        ...mapGetters({
            messages: 'messagesTableMessages',
            messagesCurrentPage: 'messagesTableMessagesCurrentPage',
            messagesLastPage: 'messagesTableMessagesLastPage',
            messagesLoading: 'messagesTableMessagesLoading'
        }),
        formattedMessages(): Message[] {
            //  If we have no messages, return empty array
            if (!this.messages) return []

            //  Else, create a container for our messages
            const msgs = []

            //  Iterate through our messages, transform, and insert into our array
            this.messages.forEach((msg: Message) => {
                //  Our current entry (must use cloneDeep here otherwise our changes affect the actual messages table)
                const curr = window._.cloneDeep(msg)

                //  Iterate through each of our transform functions
                Object.keys(this.transforms).forEach((key) => {
                    // When we are on our delivered transform we want to make sure we add the delivery date for inbound messages, this doesn't happen
                    // naturally as the delivered column is null for inbound messages in our DB, so for these messages we use the created_at date
                    if (key == 'delivered' && !msg.outbound) {
                        curr[key] = this.transforms['created_at'](msg['created_at'])
                    } else {
                        //  Apply the function and insert into the array
                        curr[key] = this.transforms[key](msg[key])
                    }
                })

                //  Push curr into our array
                msgs.push(curr)
            })

            //  Return our messages
            return msgs
        },
        menuSelectors(): object[] {
            return [
                {
                    title: 'Columns',
                    items: this.availableAttributes
                }
            ]
        },
        operator(): boolean {
            //  Grab our current role
            const role = this.$store.getters.userRole(this.$store.getters.user)

            //  Check if this role is an operator
            return window.getProps(role, ['name']) === 'Operator'
        },
        // Returns our messagestable.ts payload object which we use to paginate our filters
        payload(): object {
            return this.$store.getters.messagesTableParams
        },
        // Returns our messagestable.ts defualt payload used to reset all filters
        payloadDefault(): object {
            return this.$store.getters.messagesTableParamsExportDefault
        },
        setAttributes(): object[] {
            //  Container for our attributes
            const attr = []

            //  Iterate and add our attributes
            this.availableAttributes.forEach((x) => {
                //  If the attribute is inactive, do nothing
                if (!x.active) return

                //  Else, push it to the array
                attr.push({
                    text: x.text,
                    value: x.value,
                    divider: true
                })
            })

            //  Return our attributes
            return attr
        },
        showRefresh(): boolean {
            //  Get our total number of items per page
            const perPage = this.itemsPerPage

            //  Get our total number of messages
            const onPage = this.messages.length

            //  If we have the same amount, we are good
            if (perPage === onPage) return false

            //  Else, check our current page
            const currPage = this.messagesCurrentPage

            //  Get our last page
            const nextPage = this.messagesLastPage

            //  Check if these pages match
            const samePage = currPage === nextPage

            //  If we are on the same page, we are good
            if (samePage) return false

            //  Else, the data needs to be updated, display our button
            return true
        }
    },
    methods: {
        //  The height of the primary content
        calculateContentHeight(): number {
            //  Get the height of the view
            let body = document.body.clientHeight

            //  Define the toolbars offset
            let toolbars = 70

            //  define the padding offset (accounts for padding on smAndUp)
            let padding = 25

            //  Define the app bottom navbar offset
            let navbar = 15

            //  Subtract the height of our app bar, toolbars, navbar, and padding
            let height = body - (toolbars + padding + navbar)

            //  Return height in pixels
            this.contentHeight = height

            return height
        },
        changeScheduledMessageTime(message: Message): void {
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                title: 'Schedule Time Edit',
                component: ScheduleBuilder,
                closeable: true,
                closeOnSubmit: true,
                props: {
                    dialogOpen: true,
                    // Disables the ability to delete schedules in this pop-up which we want as we have a cancel button for scheduled messages
                    edit: true,
                    messageFeed: true,
                    message: message,
                    schedules: [message.schedule],
                    // Since message feed seperates scheuled messages as individuals, even if they are the same message scheduled over multiple
                    // time periods, we enable single option
                    single: true
                }
            })
        },
        clearSearch(): void {
            //  Keep track if search had a value
            const isDirty = this.payload.search !== null

            //  Only paginate if search is NOT null
            if (isDirty) {
                this.payload.search = ''
                this.paginateMessages(1)
            }
        },
        columnsTypeFilter(selection: FilterChoice): void {
            // Our SMS table doesn't actually contain these columns thus we cannot send them to the API
            if (selection.value === 'author' || selection.value === 'recipient') {
                return
            }

            // Call the paginateFilters function so we can apply our columnTypes that have been selected by the user
            this.paginateFilters('columnsType', selection)
        },
        deleteMessageConfirm(message: Message): void {
            this.$store.dispatch('dialogOpen', {
                type: 'CONFIRM',
                title: 'Delete Message',
                text: `Are you sure you'd like to delete this message? If yes, it will be removed from the conversation history`,
                icon: 'mdi-alert',
                color: 'primary',
                callback: (result: boolean) => this.deleteMessage(result, message)
            })
        },
        async deleteMessage(result: boolean, message: Message): Promise<void> {
            //  If no result, return
            if (!result) return

            // Else, delete the message
            const resp = await this.$store.dispatch('messagesDelete', message)

            // If there was a response, notify the user
            if (!resp) return

            //  Notify the user that we made a change
            this.$store.commit('appNotificationBarSet', {
                message: 'Message deleted successfully',
                type: 'success'
            })

            //  Re-paginate
            this.paginateMessages()
        },
        deliveryDateFilter(selection: FilterChoice): void {
            // Grab the previous filters so we know what the user already has applied to the message table
            const previousFilters = this.payload.deliveredMessages

            // We compare the users selection to their previous filters and prevent multi select based off what they choose
            this.deliveryMultiselectPrevention(selection, previousFilters)

            // We pass what filter we are changing as well as the user's selection to apply changes to our filters
            this.paginateFilters('deliveredMessages', selection)
        },
        // Only allows user to check a sort order option, (either descenidng or ascending), and check delivered or not delivered messages
        deliveryMultiselectPrevention(selection: FilterChoice, previousFilters): void {
            // We check the users selection and see if any of the currently applied filters are inverses to the users selection, if so we uncheck and remove
            // the inverse filter
            this.deliveryMultiselectPreventionHelper(
                'not delivered',
                'delivered',
                selection,
                previousFilters
            )

            this.deliveryMultiselectPreventionHelper(
                'delivered',
                'not delivered',
                selection,
                previousFilters
            )

            this.deliveryMultiselectPreventionHelper(
                'descending',
                'ascending',
                selection,
                previousFilters
            )

            this.deliveryMultiselectPreventionHelper(
                'ascending',
                'descending',
                selection,
                previousFilters
            )
        },
        // Used to help our deliveryMultiselectPrevention function by seperating logic and enabling us to resuse it for the four cases we can have
        deliveryMultiselectPreventionHelper(
            current: string,
            previous: string,
            selection: FilterChoice,
            previousFilters: Array<string>
        ): void {
            // We check if the user's filter choice is the inverse of what's currently selected (delivered/not delivered) and (descending/ascending)
            const oppositeFilter =
                previousFilters.includes(current) && selection.text === previous

            // You can only select one of the filters thus we need to remove the previous choice if it's the inverse of user's current choice
            if (oppositeFilter) {
                // Find the index of our previous choice so that we can remove it
                const previousChoiceindex = previousFilters.indexOf(current)

                // Only splice array when item is found
                if (previousChoiceindex > -1) {
                    // Remove previous choice filter from array
                    previousFilters.splice(previousChoiceindex, 1)
                }

                // We take the previous filters which now no longer contains the previousChoice and reassign it to delivered messages
                this.payload.deliveredMessages = previousFilters

                // We find the previously selected item in the array (clientside) and set it's active to false so it is no longer checked
                const deselect = this.deliveryFilters.find(
                    (previousChoice) => previousChoice.text === current
                )

                // Set the now deselected item's active value to false (removes checkmark)
                deselect.active = false
            }
        },
        editMessage(message: Message): void {
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                title: 'Edit message',
                icon: 'mdi-pencil',
                description: 'Change the message before it gets sent to your contact',
                component: 'message-edit-form',
                props: {
                    smsMessage: message
                }
            })
        },
        // Pop a failed message (re-send) dialog
        failedMessageHandler(message: Message): void {
            this.$store.dispatch('dialogOpen', {
                type: 'CONFIRM',
                title: 'Failed To Send',
                text: `Sending messages to contacts with invalid or unreachable phone numbers will result in the message being marked as "Not Delivered". Before resending, confirm that this number can receive text messages! Would you like to try resending this message?`,
                icon: 'mdi-alert-circle',
                callback: (result: boolean): void => {
                    //  If result was false do nothing
                    if (!result) return

                    //  Else, resend
                    this.resendMessageHandler(message)
                }
            })
        },
        // Used to format our message so our api can recieve it
        filterObject(obj: object): object {
            //  Our filter that we apply to our message object
            const filter = [
                'channel_id',
                'text',
                'media_id',
                'template_id',
                'author_id',
                'outbound',
                'type'
            ]

            //  Filter our object based on the filter above
            let message = window._.pick(obj, filter)

            // Since our outbound filter here returns text and not true or false we need to change that or we'll get a 422 from our api
            if (message.outbound === 'outbound') {
                message.outbound = true
            } else {
                message.outbound = false
            }

            //  Return our message
            return message
        },
        getNumOfCredits(msg: Message): number {
            //  If this is NOT outbound, return 0
            if (!msg.outbound) return 0

            //  If has media, automatic 3 credits
            if (msg.media_id !== null) return 3

            //  Return our message count
            return msg.message_count || 0
        },
        inboundOutboundFilter(selection: FilterChoice): void {
            // If the filter selected is inbound and it's checked then we apply this filter
            if (selection.text === 'inbound' && selection.active) {
                // If the user choose inbound then we change our payload to let the api know to not filter based off outbound
                this.payload.outboundMessages = false

                // We find outbound in the array of inbound outbound filters we have so we can set it's checkbox mark to false (no longer checked)
                const outbound = this.inOutFilters.find(
                    (previousChoice) => previousChoice.text === 'outbound'
                )

                // We set outbound checkbox to false that way the user cannot choose both inbound and outbound options
                outbound.active = false
            }

            // If the filter selected is outbound and it's checked then we apply this filter
            else if (selection.text === 'outbound' && selection.active) {
                // We set the payload outbound messages to true so the api knows to include outbound messages
                this.payload.outboundMessages = true

                // We find inbound in the array of inbound outbound filters we have so we can set it's checkbox mark to false (no longer checked)
                const inbound = this.inOutFilters.find(
                    (previousChoice) => previousChoice.text === 'inbound'
                )

                // We set inbox checkbox to false that way the user cannot choose both inbound and outbound options
                inbound.active = false
            }

            // Else the user hasn't had any filter options checked and thus we set it to null to show both outbound and inbound messages
            else {
                this.payload.outboundMessages = null
            }

            // Apply the user's choice if any was made and paginate our messages based off that choice
            this.paginateMessages(1)
        },
        // Used to determine styling for status text
        isMessageDelivered(msg: Message): boolean {
            return msg.status === 'delivered'
        },
        // Used to determine styling for status text
        isMessagedFailed(msg: Message): boolean {
            return msg.status === 'failed'
        },
        // Used to determine styling for status text
        isMessageScheduled(msg: Message): boolean {
            return msg.status === 'scheduled'
        },
        keyPressEvent(event: Event): void {
            //  @ts-ignore TODO
            if (event.key === 'ArrowRight') this.pageNext()
            //  @ts-ignore TODO
            else if (event.key === 'ArrowLeft') this.pageBefore()
        },
        messageSearch(text: string): void {
            // If text is not provided, return
            if (!text) return

            // Set the search
            this.payload.search = text

            // Paginate with search
            this.paginateMessages(1)

            Analytics.track('LocalSearchUsed', {
                search_type: 'Messages',
                search_query: text
            })
        },
        messageTypeFilter(selection: FilterChoice): void {
            // We call the paginate filters function and pass what filter the user has changed and paginate based off those changes
            this.paginateFilters('messagesType', selection)
        },
        pageBefore(): void {
            //  If the current page is NOT greater than 1, do nothing
            if (this.messagesCurrentPage <= 1) return

            // Else if the current page is greater than the first page, then go to the previous page
            this.paginateMessages(this.messagesCurrentPage - 1)
        },
        pageNext(): void {
            //  If the current page is greater than/equal to last page, do nothing
            if (this.messagesCurrentPage >= this.messagesLastPage) return

            // Else if the current page is less than the last page, then go to the next page
            this.paginateMessages(this.messagesCurrentPage + 1)
        },
        paginateFilters(filterType: string, selection: FilterChoice) {
            // We assign our current selction choices
            const previousFilters = this.payload[filterType]

            // If user has choice marked and we have previous filters, we add the new selected filter to the other filters they have
            if (selection.active && previousFilters) {
                // We use the list of items in the previous filter and add the user's selection to this then assign it to our payload
                this.payload[filterType] = previousFilters.concat(selection.value)
            }

            // Else if the selection they choose is now active but they don't have any other filters set, we just add the choice to the array
            else if (selection.active && !previousFilters) {
                // Assign the users selection to our payload
                this.payload[filterType] = [selection.value]
            }

            // If the filter option they chose is now unchecked and we have other filters then we find the unchecked filter and remove it
            else if (!selection.active && previousFilters) {
                // Grab the index of the item we are removing from the filter list (what the user unchecked)
                const index = previousFilters.indexOf(selection.value)

                // Only splice array when item is found
                if (index > -1) {
                    // Remove unchecked filter from array
                    previousFilters.splice(index, 1)
                }

                // We now assign the previous filters back to our payload w/o the filter the user removed
                this.payload[filterType] = previousFilters
            }

            // If this is the users first time on the page and no filters have been applied then their first filter goes through this statement
            else {
                // Assign users first filter choice here
                this.payload[filterType] = [selection.value]
            }

            // We call our paginateMessages function to send the filters to the api
            this.paginateMessages(1)
        },
        paginateMessages(page: number): void {
            // We set our current page in the store to either be the first page if any filter is applied to prevent a 2-1 page error
            // if no filter is applied we just set it to be the next or prev page
            this.payload.messagesCurrentPage = page || this.messagesCurrentPage

            // Assemble payload for page pagination and page limit
            this.payload.page = page || this.messagesCurrentPage
            this.payload.limit = this.itemsPerPage

            //  Update the params in the store
            this.$store.commit('messagesTableParamsSet', this.payload)

            //  The filter has changed, so paginate the new filter
            this.$store.dispatch('messagesTableMessagesPaginate')
        },
        // Delete the scheduled message, send the message, and re-paginate
        async resendMessageHandler(message: Message): Promise<void> {
            //  Delete the current message
            const deleted = await this.$store.dispatch('messagesDelete', message)

            //  If no response, return
            if (!deleted) return

            //  Resend the message
            this.resendMessage(message)
        },
        async resendMessage(message: Message): Promise<void> {
            //  Get a filtered payload
            const payload = this.filterObject(message)

            //  Else, dispatch with our filtered payload
            const resend = await this.$store.dispatch('messagesPost', payload)

            //  If no response, return
            if (!resend) return

            //  Else, set our notification bar
            this.$store.commit('appNotificationBarSet', {
                type: 'success',
                message: 'Message(s) Sent'
            })

            //  Paginate our messages
            this.paginateMessages()
        },
        setItemsPerPage(num: number = 15): void {
            //  Set our items per page to the parameter passed in
            this.itemsPerPage = num

            //  We have to repaginate starting from page 1, or else subsequent paginations brick
            this.paginateMessages(1)
        },
        setTableHeight(): void {
            // Get the height of the table header
            const headerHeight = this.$refs.tableHeader?.$el.clientHeight

            // Get the height of the labels row
            const labelsHeight =
                document.getElementsByClassName('v-data-table-header')[0]?.clientHeight

            // Get the height of the table footer
            const footerHeight = this.$refs.tableFooter?.$el.clientHeight

            //  Get our total height
            const height =
                this.contentHeight - headerHeight - labelsHeight - footerHeight - 8

            // Set the table height
            this.height = `${height}px`
        },
        statusTypeFilter(selection: FilterChoice): void {
            // Apply the filter choice the user made and paginate our messages based off that filer
            this.paginateFilters('status', selection)
        },
        tooltipActions(msg: Message): Button[] {
            //  Check if the message is scheduled
            const scheduled = msg.status === 'scheduled'

            //  Check if the message failed
            const failed = msg.status === 'failed'

            // The tooltip actions available for scheduled and failed messages
            return [
                {
                    hidden: !scheduled && !failed,
                    callback: () => this.editMessage(msg),
                    icon: 'mdi-pencil',
                    tooltip: 'edit message'
                },
                //  This is for resending scheduled messages
                {
                    disabledPopup: this.operator,
                    hidden: !scheduled,
                    callback: () => this.resendMessageHandler(msg),
                    icon: 'mdi-send',
                    tooltip: 'send message'
                },
                //  This is for resending failed messages
                {
                    disabledPopup: this.operator,
                    hidden: !failed,
                    callback: () => this.failedMessageHandler(msg),
                    icon: 'mdi-send',
                    tooltip: 'send message'
                },
                {
                    disabledPopup: this.operator,
                    callback: () => this.deleteMessageConfirm(msg),
                    icon: 'mdi-delete',
                    tooltip: 'delete message'
                },
                {
                    hidden: !scheduled,
                    callback: () => this.changeScheduledMessageTime(msg),
                    icon: 'mdi-calendar',
                    tooltip: 'Change Scheduled Time'
                }
            ]
        }
    },
    watch: {
        contentHeight(): void {
            this.setTableHeight()
        }
    }
})
